module.exports = __webpack_public_path__ + "static/media/tiktok-white.02d68df7.svg";